import * as React from 'react';
import {
    Card, CardContent, Typography, Grid, Box, Button, Table, TableBody,
    TableCell, TableContainer, TableHead, TableRow, Paper, Chip,
    CircularProgress, Alert, IconButton, Menu, MenuItem, FormControlLabel,
    Checkbox, Tooltip, Badge, TextField, InputAdornment, Switch,
    FormControl, InputLabel, Select, Divider, Avatar, Dialog,
    DialogTitle, DialogContent, DialogActions, TablePagination
} from '@mui/material';
import { useNotify } from 'react-admin';
import { useNavigate } from 'react-router-dom';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import SportsIcon from '@mui/icons-material/Sports';
import SoccerIcon from '@mui/icons-material/SportsSoccer';
import SettingsIcon from '@mui/icons-material/Settings';
import SearchIcon from '@mui/icons-material/Search';
import RefreshIcon from '@mui/icons-material/Refresh';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import GetAppIcon from '@mui/icons-material/GetApp';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import EditIcon from '@mui/icons-material/Edit';
import InfoIcon from '@mui/icons-material/Info';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import ScheduleIcon from '@mui/icons-material/Schedule';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ClearIcon from '@mui/icons-material/Clear';
import StarIcon from '@mui/icons-material/Star';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PendingIcon from '@mui/icons-material/Pending';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CropSquareIcon from '@mui/icons-material/CropSquare';
import StopIcon from '@mui/icons-material/Stop';
import { motion } from 'framer-motion';
import axios from 'axios';
import config from '../../config/config.json';
import PartitaDetailDialog from './PartitaDetailDialog';

const host = config.production.host;

// Funzione per recuperare il token JWT
const getJwt = () => {
    return localStorage.getItem("feathers-jwt");
};

const getUsersId = () => {
    // parse id in intero
    return parseInt(localStorage.getItem("RaStore.profile.idUser"));
};

function PartitePage() {
    const notify = useNotify();
    const navigate = useNavigate();

    // State principale
    const [partite, setPartite] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);
    const [searchTerm, setSearchTerm] = React.useState('');
    const [fullscreen, setFullscreen] = React.useState(false);
    const [autoRefresh, setAutoRefresh] = React.useState(false);
    const [refreshInterval, setRefreshInterval] = React.useState(null);

    // Filtri
    const [filterLega, setFilterLega] = React.useState('all');

    // Filtro automatico da query string (legaId)
    React.useEffect(() => {
        let legaId = null;
        // 1. Prova da search
        const searchParams = new URLSearchParams(window.location.search);
        legaId = searchParams.get('legaId');
        // 2. Prova da hash (HashRouter)
        if (!legaId && window.location.hash) {
            const hash = window.location.hash;
            const idx = hash.indexOf('?');
            if (idx !== -1) {
                const hashQuery = hash.substring(idx + 1);
                const hashParams = new URLSearchParams(hashQuery);
                legaId = hashParams.get('legaId');
            }
        }
        if (legaId && legaId !== 'all') {
            setFilterLega(legaId);
        }
    }, []);
    const [filterStagione, setFilterStagione] = React.useState('all');
    const [filterGiornata, setFilterGiornata] = React.useState('all');
    const [filterStatus, setFilterStatus] = React.useState('all');
    const [filterDisputata, setFilterDisputata] = React.useState('all');

    // Dialog
    const [selectedPartita, setSelectedPartita] = React.useState(null);
    const [dialogOpen, setDialogOpen] = React.useState(false);

    // Goal della partita selezionata
    const [goalPartita, setGoalPartita] = React.useState([]);
    const [loadingGoal, setLoadingGoal] = React.useState(false);
    const [playersData, setPlayersData] = React.useState([]);

    // Cartellini della partita selezionata
    const [cartellinoPartita, setCartellinoPartita] = React.useState([]);
    const [loadingCartellini, setLoadingCartellini] = React.useState(false);

    // MVP della partita selezionata
    const [mvpPartita, setMvpPartita] = React.useState([]);
    const [loadingMvp, setLoadingMvp] = React.useState(false);

    // Paginazione
    const [page, setPage] = React.useState(0);
    const [limit, setLimit] = React.useState(25);
    const [total, setTotal] = React.useState(0);

    // Dropdown data
    const [leghe, setLeghe] = React.useState([]);
    const [stagioni, setStagioni] = React.useState([]);
    const [giornate, setGiornate] = React.useState([]);

    // Loading states per dropdown
    const [loadingStagioni, setLoadingStagioni] = React.useState(false);
    const [loadingGiornate, setLoadingGiornate] = React.useState(false);

    // UI State
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [sortConfig, setSortConfig] = React.useState({ key: 'data', direction: 'desc' });

    // Dialog che si palesa al click sul punto interrogativo
    const [resultDialogOpen, setResultDialogOpen] = React.useState(false);
    const [selectedPartitaResult, setSelectedPartitaResult] = React.useState(null);
    const [risultatiPartita, setRisultatiPartita] = React.useState([]);
    const [loadingRisultati, setLoadingRisultati] = React.useState(false);
    const [loadingRendiUfficiale, setLoadingRendiUfficiale] = React.useState(null);

    // Form per nuovo risultato
    const [showAddResultForm, setShowAddResultForm] = React.useState(false);
    const [newResultForm, setNewResultForm] = React.useState({
        goalCasa: 0,
        goalOspite: 0,
        note: '',
        flUfficiale: 0
    });
    const [creatingResult, setCreatingResult] = React.useState(false);

    // Aggiungi questa nuova funzione handler
    const handleShowResult = async (partita) => {
        setSelectedPartitaResult(partita);
        setResultDialogOpen(true);

        // Carica tutti i risultati della partita
        try {
            setLoadingRisultati(true);
            const jwt = getJwt();
            const response = await axios.get(`${host}/proc-get-risultato`, {
                headers: { 'Authorization': `Bearer ${jwt}` },
                params: {
                    partitaId: partita.partitaId
                }
            });

            // Converte l'oggetto data in array e ordina per ID
            const dataObj = response.data.data || {};
            const risultatiArray = Object.values(dataObj).sort((a, b) => a.Id - b.Id);
            setRisultatiPartita(risultatiArray);

        } catch (error) {
            console.error("Errore nel caricamento risultati:", error);
            notify("Errore nel caricamento dei risultati", { type: 'error' });
            setRisultatiPartita([]);
        } finally {
            setLoadingRisultati(false);
        }
    };

    // Nuova funzione per rendere ufficiale un risultato
    const handleRendiUfficiale = async (risultatoId) => {
        try {
            setLoadingRendiUfficiale(risultatoId);
            const jwt = getJwt();

            const response = await axios.patch(
                `${host}/proc-imposta-risultato-ufficiale/${risultatoId}`,
                {},
                {
                    headers: { 'Authorization': `Bearer ${jwt}` }
                }
            );

            if (response.data.esito === 1) {
                notify(
                    `Risultato reso ufficiale! ${response.data.operazioni_effettuate?.altri_risultati_disattivati || 0} altri risultati disattivati`,
                    { type: 'success' }
                );

                // Ricarica i risultati della partita per aggiornare la vista
                const updatedResponse = await axios.get(`${host}/proc-get-risultato`, {
                    headers: { 'Authorization': `Bearer ${jwt}` },
                    params: {
                        partitaId: selectedPartitaResult.partitaId
                    }
                });

                const dataObj = updatedResponse.data.data || {};
                const risultatiArray = Object.values(dataObj).sort((a, b) => a.Id - b.Id);
                setRisultatiPartita(risultatiArray);

                // Ricarica anche la tabella principale delle partite
                loadPartite();
            }

        } catch (error) {
            console.error("Errore nel rendere ufficiale il risultato:", error);
            const errorMessage = error.response?.data?.message || error.message || "Errore sconosciuto";
            notify(`Errore: ${errorMessage}`, { type: 'error' });
        } finally {
            setLoadingRendiUfficiale(null);
        }
    };

    // Funzione per creare un nuovo risultato
    const handleCreaRisultato = async () => {
        if (!selectedPartitaResult) return;

        try {
            setCreatingResult(true);
            const jwt = getJwt();

            const response = await axios.get(
                `${host}/dynamic-proc`,
                {
                    headers: { 'Authorization': `Bearer ${jwt}` },
                    params: {
                        proc_name: 'proc_crea_risultato',
                        in_usersId: getUsersId(),
                        in_partitaId: selectedPartitaResult.partitaId,
                        in_goalCasa: parseInt(newResultForm.goalCasa),
                        in_goalOspite: parseInt(newResultForm.goalOspite),
                        in_note: newResultForm.note || null,
                        in_flUfficiale: parseInt(newResultForm.flUfficiale)
                    }
                }
            );

            if (response.data.output_params?.out_esito === 1) {
                const message = response.data.output_params.out_msg || 'Risultato creato con successo!';
                notify(message, { type: 'success' });

                // Reset form
                setNewResultForm({
                    goalCasa: 0,
                    goalOspite: 0,
                    note: '',
                    flUfficiale: 0
                });
                setShowAddResultForm(false);

                // Ricarica i risultati
                const updatedResponse = await axios.get(`${host}/proc-get-risultato`, {
                    headers: { 'Authorization': `Bearer ${jwt}` },
                    params: {
                        partitaId: selectedPartitaResult.partitaId
                    }
                });

                const dataObj = updatedResponse.data.data || {};
                const risultatiArray = Object.values(dataObj).sort((a, b) => a.Id - b.Id);
                setRisultatiPartita(risultatiArray);

                // Ricarica anche la tabella principale
                loadPartite();
            }

        } catch (error) {
            console.error("Errore nella creazione del risultato:", error);
            const errorMessage = error.response?.data?.message || error.message || "Errore sconosciuto";
            notify(`Errore: ${errorMessage}`, { type: 'error' });
        } finally {
            setCreatingResult(false);
        }
    };

    // Funzione per caricare i goal della partita selezionata
    const loadGoalPartita = async (partitaId) => {
        if (!partitaId) return;

        try {
            setLoadingGoal(true);
            const jwt = getJwt();

            // Carica i goal della partita
            const goalResponse = await axios.get(`${host}/tbl-goal`, {
                headers: {
                    'Authorization': `Bearer ${jwt}`,
                    'Content-Type': 'application/json'
                },
                params: {
                    partitaId: partitaId,
                    $sort: { minuto: 1 } // Ordina per minuto crescente
                }
            });

            const goals = goalResponse.data.data || [];

            // Se ci sono goal, carica i dati dei giocatori
            if (goals.length > 0) {
                const playerIds = [...new Set(goals.map(goal => goal.playerId))];

                // Carica i giocatori uno per uno (alternativa più sicura)
                const playersPromises = playerIds.map(playerId =>
                    axios.get(`${host}/v-player`, {
                        headers: {
                            'Authorization': `Bearer ${jwt}`,
                            'Content-Type': 'application/json'
                        },
                        params: {
                            playerId: playerId,
                            $limit: 1
                        }
                    })
                );

                const playersResponses = await Promise.all(playersPromises);
                const players = playersResponses.flatMap(response => response.data.data || []);
                setPlayersData(players);

                // Arricchisci i goal con i dati dei giocatori
                const enrichedGoals = goals.map(goal => {
                    const player = players.find(p => p.playerId === goal.playerId);
                    return {
                        ...goal,
                        playerName: player ? player.nomeGiocatore : `Giocatore ${goal.playerId}`,
                        playerTeam: player ? player.nomeTeam : null,
                        playerFoto: player ? player.foto : null
                    };
                });

                setGoalPartita(enrichedGoals);
            } else {
                setGoalPartita([]);
                setPlayersData([]);
            }

        } catch (error) {
            console.error("Errore nel caricamento goal:", error);
            notify("Errore nel caricamento dei goal", { type: 'error' });
            setGoalPartita([]);
            setPlayersData([]);
        } finally {
            setLoadingGoal(false);
        }
    };

    // Funzione per caricare i cartellini della partita selezionata
    const loadCartellinoPartita = async (partitaId) => {
        if (!partitaId) return;

        try {
            setLoadingCartellini(true);
            const jwt = getJwt();

            // Carica i cartellini della partita
            const cartellinoResponse = await axios.get(`${host}/tbl-cartellino`, {
                headers: {
                    'Authorization': `Bearer ${jwt}`,
                    'Content-Type': 'application/json'
                },
                params: {
                    partitaId: partitaId,
                    $sort: { minuto: 1 } // Ordina per minuto crescente
                }
            });

            const cartellini = cartellinoResponse.data.data || [];

            // Se ci sono cartellini, carica i dati dei giocatori
            if (cartellini.length > 0) {
                const playerIds = [...new Set(cartellini.map(cartellino => cartellino.playerId))];

                // Carica i giocatori uno per uno (alternativa più sicura)
                const playersPromises = playerIds.map(playerId =>
                    axios.get(`${host}/v-player`, {
                        headers: {
                            'Authorization': `Bearer ${jwt}`,
                            'Content-Type': 'application/json'
                        },
                        params: {
                            playerId: playerId,
                            $limit: 1
                        }
                    })
                );

                const playersResponses = await Promise.all(playersPromises);
                const players = playersResponses.flatMap(response => response.data.data || []);

                // Carica anche i tipi di cartellino
                const tipoCartellinoIds = [...new Set(cartellini.map(cartellino => cartellino.tipoCartellinoId))];
                const tipoCartellinoPromises = tipoCartellinoIds.map(tipoId =>
                    axios.get(`${host}/tbl-tipocartellino`, {
                        headers: {
                            'Authorization': `Bearer ${jwt}`,
                            'Content-Type': 'application/json'
                        },
                        params: {
                            id: tipoId,
                            $limit: 1
                        }
                    })
                );

                const tipoCartellinoResponses = await Promise.all(tipoCartellinoPromises);
                const tipiCartellino = tipoCartellinoResponses.flatMap(response => response.data.data || []);

                // Arricchisci i cartellini con i dati dei giocatori e tipi cartellino
                const enrichedCartellini = cartellini.map(cartellino => {
                    const player = players.find(p => p.playerId === cartellino.playerId);
                    const tipoCartellino = tipiCartellino.find(t => t.id === cartellino.tipoCartellinoId);

                    return {
                        ...cartellino,
                        playerName: player ? player.nomeGiocatore : `Giocatore ${cartellino.playerId}`,
                        playerTeam: player ? player.nomeTeam : null,
                        playerFoto: player ? player.foto : null,
                        tipoCartellinoNome: tipoCartellino ? tipoCartellino.nome : 'SCONOSCIUTO',
                        tipoCartellino: tipoCartellino ? tipoCartellino.nome.toLowerCase() : 'altro'
                    };
                });

                setCartellinoPartita(enrichedCartellini);
            } else {
                setCartellinoPartita([]);
            }

        } catch (error) {
            console.error("Errore nel caricamento cartellini:", error);
            notify("Errore nel caricamento dei cartellini", { type: 'error' });
            setCartellinoPartita([]);
        } finally {
            setLoadingCartellini(false);
        }
    };

    // Funzione per caricare gli MVP della partita selezionata
    const loadMvpPartita = async (partitaId) => {
        if (!partitaId) return;

        try {
            setLoadingMvp(true);
            const jwt = getJwt();

            // Carica gli MVP della partita
            const mvpResponse = await axios.get(`${host}/tbl-mvp`, {
                headers: {
                    'Authorization': `Bearer ${jwt}`,
                    'Content-Type': 'application/json'
                },
                params: {
                    partitaId: partitaId
                }
            });

            const mvps = mvpResponse.data.data || [];

            // Se ci sono MVP, carica i dati dei giocatori
            if (mvps.length > 0) {
                const playerIds = [...new Set(mvps.map(mvp => mvp.playerId))];

                // Carica i giocatori uno per uno (alternativa più sicura)
                const playersPromises = playerIds.map(playerId =>
                    axios.get(`${host}/v-player`, {
                        headers: {
                            'Authorization': `Bearer ${jwt}`,
                            'Content-Type': 'application/json'
                        },
                        params: {
                            playerId: playerId,
                            $limit: 1
                        }
                    })
                );

                const playersResponses = await Promise.all(playersPromises);
                const players = playersResponses.flatMap(response => response.data.data || []);

                // Arricchisci gli MVP con i dati dei giocatori
                const enrichedMvps = mvps.map(mvp => {
                    const player = players.find(p => p.playerId === mvp.playerId);
                    return {
                        ...mvp,
                        playerName: player ? player.nomeGiocatore : `Giocatore ${mvp.playerId}`,
                        playerTeam: player ? player.nomeTeam : null,
                        playerFoto: player ? player.foto : null
                    };
                });

                setMvpPartita(enrichedMvps);
            } else {
                setMvpPartita([]);
            }

        } catch (error) {
            console.error("Errore nel caricamento MVP:", error);
            notify("Errore nel caricamento degli MVP", { type: 'error' });
            setMvpPartita([]);
        } finally {
            setLoadingMvp(false);
        }
    };

    // Configurazione delle colonne (identica al codice originale)
    const COLUMN_CONFIG = {
        data: {
            label: 'Data/Ora',
            key: 'data',
            align: 'center',
            default: true,
            sortable: true,
            width: 140,
            render: (value, row) => (
                <Box sx={{ textAlign: 'center' }}>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                        {value ? new Date(value).toLocaleDateString('it-IT') : 'N/A'}
                    </Typography>
                    {row.ore && (
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                            <ScheduleIcon sx={{ fontSize: 12 }} />
                            {row.ore}
                        </Typography>
                    )}
                </Box>
            )
        },
        scontro: {
            label: 'Scontro',
            key: 'scontro',
            align: 'center',
            default: true,
            sortable: false,
            width: 280,
            render: (value, row) => (
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                    {/* Team Casa */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1, justifyContent: 'flex-end' }}>
                        <Typography variant="body2" sx={{ fontWeight: 500, textAlign: 'right' }}>
                            {row.teamCasaNome || 'Casa'}
                        </Typography>
                        <Avatar
                            src={row.teamCasaFoto}
                            alt={row.teamCasaNome}
                            sx={{ width: 24, height: 24 }}
                        >
                            {row.teamCasaNome?.charAt(0)}
                        </Avatar>
                    </Box>

                    {/* Risultato */}
                    <Box sx={{
                        bgcolor: row.flDisputata ? '#e8f5e8' : '#f5f5f5',
                        px: 1.5,
                        py: 0.5,
                        borderRadius: 1,
                        minWidth: 50,
                        textAlign: 'center'
                    }}>
                        {row.flDisputata ? (
                            <Typography variant="body2" sx={{ fontWeight: 700, color: '#2e7d32' }}>
                                {row.goalCasa || 0} - {row.goalOspite || 0}
                            </Typography>
                        ) : (
                            <Typography variant="caption" color="text.secondary">
                                vs
                            </Typography>
                        )}
                    </Box>

                    {/* Team Ospite */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1, justifyContent: 'flex-start' }}>
                        <Avatar
                            src={row.teamOspiteFoto}
                            alt={row.teamOspiteNome}
                            sx={{ width: 24, height: 24 }}
                        >
                            {row.teamOspiteNome?.charAt(0)}
                        </Avatar>
                        <Typography variant="body2" sx={{ fontWeight: 500, textAlign: 'left' }}>
                            {row.teamOspiteNome || 'Ospite'}
                        </Typography>
                    </Box>
                </Box>
            )
        },
        giornataNumero: {
            label: 'Giornata',
            key: 'giornataNumero',
            align: 'center',
            default: true,
            sortable: true,
            width: 120,
            render: (value, row) => (
                <Box sx={{ textAlign: 'center' }}>
                    <Chip
                        label={row.giornataNome || `G${row.giornataNumero || '?'}`}
                        size="small"
                        sx={{
                            bgcolor: '#e3f2fd',
                            color: '#1565c0',
                            fontWeight: 500,
                            mb: 0.5,
                            cursor: 'pointer',
                            textDecoration: 'underline'
                        }}
                        icon={<CalendarTodayIcon sx={{ fontSize: 16 }} />}
                        onClick={() => navigate(`/giornate/${row.giornataId}`)}
                    />
                </Box>
            )
        },
        lega: {
            label: 'Lega',
            key: 'lega',
            align: 'center',
            default: false,
            sortable: true,
            width: 120,
            render: (value, row) => (
                <Box sx={{ textAlign: 'center' }}>
                    <Chip
                        label={row.legaNome || `Lega ${row.legaId}`}
                        size="small"
                        sx={{
                            bgcolor: '#fff3e0',
                            color: '#e65100',
                            fontWeight: 500
                        }}
                        icon={<EmojiEventsIcon sx={{ fontSize: 16 }} />}
                    />
                </Box>
            )
        },
        stagione: {
            label: 'Stagione',
            key: 'stagione',
            align: 'center',
            default: false,
            sortable: true,
            width: 120,
            render: (value, row) => (
                <Box sx={{ textAlign: 'center' }}>
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                        {row.stagioneNome || `Stagione ${row.stagioneId}`}
                    </Typography>
                </Box>
            )
        },
        luogo: {
            label: 'Luogo',
            key: 'luogo',
            align: 'center',
            default: false,
            sortable: true,
            width: 150,
            render: (value) => (
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                    <LocationOnIcon sx={{ fontSize: 16, color: '#757575' }} />
                    <Typography variant="body2">
                        {value || 'N/A'}
                    </Typography>
                </Box>
            )
        },
        risultato: {
            label: 'Risultato',
            key: 'risultato',
            align: 'center',
            default: true,
            sortable: false,
            width: 150, // Aumentato per contenere l'icona
            render: (value, row) => (
                <Box sx={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                    {row.flDisputata ? (
                        <>
                            <Box>
                                <Typography variant="h6" sx={{ fontWeight: 700, color: '#2e7d32' }}>
                                    {row.goalCasa || 0} - {row.goalOspite || 0}
                                </Typography>
                                {row.risultatoUfficiale && (
                                    <Chip
                                        label="Ufficiale"
                                        size="small"
                                        sx={{
                                            bgcolor: '#e8f5e8',
                                            color: '#2e7d32',
                                            fontSize: '0.6rem',
                                            height: 18
                                        }}
                                    />
                                )}
                            </Box>
                            <Tooltip title="Visualizza dettagli risultato">
                                <IconButton
                                    size="small"
                                    onClick={() => handleShowResult(row)}
                                    sx={{
                                        bgcolor: '#e3f2fd',
                                        color: '#1976d2',
                                        '&:hover': {
                                            bgcolor: '#bbdefb'
                                        },
                                        width: 24,
                                        height: 24
                                    }}
                                >
                                    <HelpOutlineIcon sx={{ fontSize: 16 }} />
                                </IconButton>
                            </Tooltip>
                        </>
                    ) : (
                        <Typography variant="body2" color="text.secondary">
                            Da giocare
                        </Typography>
                    )}
                </Box>
            )
        },
        flDisputata: {
            label: 'Stato',
            key: 'flDisputata',
            align: 'center',
            default: true,
            sortable: true,
            width: 120,
            render: (value, row) => {
                let status = 'Attiva';
                let color = '#4caf50';
                let bgcolor = '#e8f5e8';
                let icon = <CheckCircleIcon sx={{ fontSize: 16 }} />;

                if (row.flAnnullato) {
                    status = 'Annullata';
                    color = '#f44336';
                    bgcolor = '#ffebee';
                    icon = <ClearIcon sx={{ fontSize: 16 }} />;
                } else if (!row.flAttivo) {
                    status = 'Inattiva';
                    color = '#ff9800';
                    bgcolor = '#fff3e0';
                    icon = <PendingIcon sx={{ fontSize: 16 }} />;
                } else if (!row.flVisibile) {
                    status = 'Nascosta';
                    color = '#9e9e9e';
                    bgcolor = '#f5f5f5';
                    icon = <VisibilityOffIcon sx={{ fontSize: 16 }} />;
                } else if (row.flDisputata) {
                    status = 'Disputata';
                    color = '#2e7d32';
                    bgcolor = '#e8f5e8';
                    icon = <SoccerIcon sx={{ fontSize: 16 }} />;
                } else {
                    status = 'Da giocare';
                    color = '#1976d2';
                    bgcolor = '#e3f2fd';
                    icon = <ScheduleIcon sx={{ fontSize: 16 }} />;
                }

                return (
                    <Chip
                        label={status}
                        size="small"
                        sx={{ color, bgcolor, fontWeight: 500 }}
                        icon={icon}
                    />
                );
            }
        },
        ordinamento: {
            label: 'Ordine',
            key: 'ordinamento',
            align: 'center',
            default: false,
            sortable: true,
            width: 80,
            render: (value) => (
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                    <StarIcon sx={{ fontSize: 16, color: '#ff9800' }} />
                    <Typography variant="body2">
                        {value || '-'}
                    </Typography>
                </Box>
            )
        },
        createdAt: {
            label: 'Creata il',
            key: 'createdAt',
            align: 'center',
            default: false,
            sortable: true,
            width: 120,
            render: (value) => (
                <Typography variant="body2">
                    {value ? new Date(value).toLocaleDateString('it-IT') : '-'}
                </Typography>
            )
        },
        updatedAt: {
            label: 'Aggiornata il',
            key: 'updatedAt',
            align: 'center',
            default: false,
            sortable: true,
            width: 120,
            render: (value) => (
                <Typography variant="body2">
                    {value ? new Date(value).toLocaleDateString('it-IT') : '-'}
                </Typography>
            )
        },
        actions: {
            label: 'Azioni',
            key: 'actions',
            align: 'center',
            default: true,
            sortable: false,
            width: 120,
            render: (value, row) => (
                <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'center' }}>
                    <Tooltip title="Visualizza dettagli">
                        <IconButton size="small" onClick={() => handleViewPartita(row)}>
                            <InfoIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>

                    <Tooltip title={row.flVisibile ? "Nascondi" : "Mostra"}>
                        <IconButton
                            size="small"
                            onClick={() => handleToggleVisibility(row)}
                            color={row.flVisibile ? "default" : "warning"}
                        >
                            {row.flVisibile ? <VisibilityIcon fontSize="small" /> : <VisibilityOffIcon fontSize="small" />}
                        </IconButton>
                    </Tooltip>
                </Box>
            )
        }
    };

    // Configurazione colonne visibili
    const [visibleColumns, setVisibleColumns] = React.useState(() => {
        const saved = localStorage.getItem('partite-visible-columns');
        if (saved) {
            try {
                const parsed = JSON.parse(saved);
                return parsed.filter(col => Object.keys(COLUMN_CONFIG).includes(col));
            } catch (e) {
                console.warn('Errore nel parsing delle colonne salvate:', e);
            }
        }
        return ['data', 'scontro', 'giornataNumero', 'risultato', 'flDisputata', 'actions'];
    });

    // Handlers
    const handleViewPartita = (partita) => {
        // Naviga alla pagina di dettaglio partita
        navigate(`/partite/${partita.partitaId}`);
    };



    const handleToggleVisibility = async (partita) => {
        try {
            const jwt = getJwt();
            await axios.patch(
                `${host}/tbl-partita/${partita.partitaId}`,
                { flVisibile: !partita.flVisibile },
                { headers: { 'Authorization': `Bearer ${jwt}` } }
            );

            notify(`Partita ${partita.flVisibile ? 'nascosta' : 'mostrata'}`, { type: 'success' });
            loadPartite();
        } catch (error) {
            notify("Errore nell'aggiornamento", { type: 'error' });
        }
    };

    // Gestione cambio filtro Lega - CASCADE
    const handleLegaChange = async (value) => {
        setFilterLega(value);

        // Rimuovi i parametri di filtro dall’URL (sia query string che hash)
        if (window.location.search || window.location.hash.includes('?')) {
            if (window.history && window.history.replaceState) {
                const path = window.location.pathname + (window.location.hash.split('?')[0] || '');
                window.history.replaceState({}, '', path);
            }
        }

        // Reset filtri dipendenti
        setFilterStagione('all');
        setFilterGiornata('all');
        setStagioni([]);
        setGiornate([]);
        setPage(0);

        // Se ho selezionato una lega specifica, carico le stagioni
        if (value !== 'all') {
            await loadStagioniByLega(value);
        }
    };

    // Gestione cambio filtro Stagione - CASCADE
    const handleStagioneChange = async (value) => {
        setFilterStagione(value);

        // Reset filtro dipendente
        setFilterGiornata('all');
        setGiornate([]);
        setPage(0);

        // Se ho selezionato una stagione specifica e una lega, carico le giornate
        if (value !== 'all' && filterLega !== 'all') {
            await loadGiornateByLegaStagione(filterLega, value);
        }
    };

    // Gestione cambio filtro Giornata
    const handleGiornataChange = (value) => {
        setFilterGiornata(value);
        setPage(0);
    };

    // Costruisce query FeathersJS (identica al codice originale)
    const buildQuery = () => {
        const query = {
            $limit: limit,
            $skip: page * limit
        };

        // Ordinamento
        if (sortConfig.key && COLUMN_CONFIG[sortConfig.key]?.sortable) {
            query.$sort = {
                [sortConfig.key]: sortConfig.direction === 'asc' ? 1 : -1
            };
        }

        // Filtri
        const filters = {};

        // Ricerca testuale
        if (searchTerm.trim()) {
            const search = `%${searchTerm.trim()}%`;
            filters.$or = [
                { teamCasaNome: { $like: search } },
                { teamOspiteNome: { $like: search } },
                { giornataNome: { $like: search } },
                { legaNome: { $like: search } },
                { luogo: { $like: search } },
                { note: { $like: search } }
            ];
        }

        // Filtri specifici
        if (filterLega !== 'all') filters.legaId = parseInt(filterLega);
        if (filterStagione !== 'all') filters.stagioneId = parseInt(filterStagione);
        if (filterGiornata !== 'all') filters.giornataId = parseInt(filterGiornata);
        if (filterDisputata !== 'all') filters.flDisputata = filterDisputata === 'disputata' ? 1 : 0;

        // Filtro status
        if (filterStatus !== 'all') {
            switch (filterStatus) {
                case 'active':
                    filters.flAttivo = true;
                    filters.flAnnullato = false;
                    break;
                case 'inactive':
                    filters.flAttivo = false;
                    filters.flAnnullato = false;
                    break;
                case 'hidden':
                    filters.flVisibile = false;
                    break;
                case 'cancelled':
                    filters.flAnnullato = true;
                    break;
            }
        }

        if (Object.keys(filters).length > 0) {
            Object.assign(query, filters);
        }

        return query;
    };

    // API Calls
    const loadPartite = async () => {
        try {
            setLoading(true);
            setError(null);
            const jwt = getJwt();
            const query = buildQuery();

            const response = await axios.get(`${host}/v-partita`, {
                headers: { 'Authorization': `Bearer ${jwt}` },
                params: query
            });

            const data = response.data;
            setPartite(data.data || []);
            setTotal(data.total || 0);

        } catch (error) {
            console.error("Errore nel recupero partite:", error);
            setError("Errore nel caricamento delle partite");
            notify("Errore nel caricamento delle partite", { type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    // Carica lista leghe (invariata)
    const loadLeghe = async () => {
        try {
            const jwt = getJwt();
            const response = await axios.get(`${host}/tbl-lega`, {
                headers: { 'Authorization': `Bearer ${jwt}` },
                params: {
                    $select: ['id', 'nome'],
                    flVisibile: 1,
                    flAttivo: 1,
                    $sort: { nome: 1 }
                }
            });
            setLeghe(response.data.data || []);
        } catch (error) {
            console.error("Errore nel caricamento leghe:", error);
            notify("Errore nel caricamento leghe", { type: 'error' });
        }
    };

    // NUOVA: Carica stagioni per lega specifica tramite procedura
    const loadStagioniByLega = async (legaId) => {
        try {
            setLoadingStagioni(true);
            const jwt = getJwt();
            const response = await axios.get(`${host}/proc-get-stagione-elenco`, {
                headers: { 'Authorization': `Bearer ${jwt}` },
                params: {
                    p_input_legaId_dal: legaId,
                    p_input_legaId_al: legaId
                }
            });

            console.log('Risposta stagioni:', response.data); // Debug

            const data = response.data;
            // Verifica se la risposta ha la struttura corretta
            const stagioniArray = Array.isArray(data.data) ? data.data :
                Array.isArray(data) ? data : [];

            setStagioni(stagioniArray);
        } catch (error) {
            console.error("Errore nel caricamento stagioni:", error);
            notify("Errore nel caricamento stagioni", { type: 'error' });
            setStagioni([]);
        } finally {
            setLoadingStagioni(false);
        }
    };

    // NUOVA: Carica giornate per lega+stagione tramite procedura
    const loadGiornateByLegaStagione = async (legaId, stagioneId) => {
        try {
            setLoadingGiornate(true);
            const jwt = getJwt();
            const response = await axios.get(`${host}/proc-get-giornata-elenco`, {
                headers: { 'Authorization': `Bearer ${jwt}` },
                params: {
                    p_input_legaId_dal: legaId,
                    p_input_legaId_al: legaId,
                    p_input_stagioneId_dal: stagioneId,
                    p_input_stagioneId_al: stagioneId
                }
            });

            console.log('Risposta giornate:', response.data); // Debug

            const data = response.data;
            // Verifica se la risposta ha la struttura corretta
            const giornateArray = Array.isArray(data.data) ? data.data :
                Array.isArray(data) ? data : [];

            setGiornate(giornateArray);
        } catch (error) {
            console.error("Errore nel caricamento giornate:", error);
            notify("Errore nel caricamento giornate", { type: 'error' });
            setGiornate([]);
        } finally {
            setLoadingGiornate(false);
        }
    };

    // Utility handlers (identici al codice originale)
    const handleColumnToggle = (columnKey) => {
        if (!COLUMN_CONFIG[columnKey]) {
            console.warn(`Colonna ${columnKey} non trovata in COLUMN_CONFIG`);
            return;
        }

        setVisibleColumns(prev => {
            if (prev.includes(columnKey)) {
                return prev.filter(key => key !== columnKey);
            } else {
                return [...prev, columnKey];
            }
        });
    };

    const handleSort = (columnKey) => {
        if (!COLUMN_CONFIG[columnKey]?.sortable) return;

        setSortConfig(prev => ({
            key: columnKey,
            direction: prev.key === columnKey && prev.direction === 'desc' ? 'asc' : 'desc'
        }));
    };

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    const handleLimitChange = (event) => {
        setLimit(parseInt(event.target.value, 10));
        setPage(0);
    };

    const resetFilters = () => {
        setSearchTerm('');
        setFilterLega('all');
        setFilterStagione('all');
        setFilterGiornata('all');
        setFilterStatus('all');
        setFilterDisputata('all');
        setStagioni([]);
        setGiornate([]);
        setPage(0);
    };

    const resetToDefault = () => {
        setVisibleColumns(['data', 'scontro', 'giornataNumero', 'risultato', 'flDisputata', 'actions']);
        setAnchorEl(null);
    };

    const exportToCSV = () => {
        const headers = visibleColumns
            .filter(key => key !== 'actions' && COLUMN_CONFIG[key])
            .map(key => COLUMN_CONFIG[key].label)
            .join(',');

        const rows = partite.map(partita =>
            visibleColumns
                .filter(key => key !== 'actions' && COLUMN_CONFIG[key])
                .map(key => {
                    let value = partita[key] || '';
                    if (key === 'scontro') {
                        value = `${partita.teamCasaNome || 'Casa'} vs ${partita.teamOspiteNome || 'Ospite'}`;
                    } else if (key === 'risultato') {
                        value = partita.flDisputata ? `${partita.goalCasa || 0}-${partita.goalOspite || 0}` : 'Da giocare';
                    } else if (key === 'flDisputata') {
                        if (partita.flAnnullato) value = 'Annullata';
                        else if (!partita.flAttivo) value = 'Inattiva';
                        else if (!partita.flVisibile) value = 'Nascosta';
                        else if (partita.flDisputata) value = 'Disputata';
                        else value = 'Da giocare';
                    } else if (key === 'data') {
                        value = partita.data ? new Date(partita.data).toLocaleDateString('it-IT') : '';
                    }
                    return `"${value}"`;
                }).join(',')
        ).join('\n');

        const csv = headers + '\n' + rows;
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', `partite_${new Date().toISOString().split('T')[0]}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const toggleFullscreen = () => {
        setFullscreen(!fullscreen);
    };

    // Effects
    React.useEffect(() => {
        if (autoRefresh) {
            const interval = setInterval(() => {
                loadPartite();
            }, 30000);
            setRefreshInterval(interval);
        } else {
            if (refreshInterval) {
                clearInterval(refreshInterval);
                setRefreshInterval(null);
            }
        }

        return () => {
            if (refreshInterval) {
                clearInterval(refreshInterval);
            }
        };
    }, [autoRefresh]);

    React.useEffect(() => {
        loadPartite();
    }, [page, limit, sortConfig, searchTerm, filterLega, filterStagione, filterGiornata, filterStatus, filterDisputata]);

    React.useEffect(() => {
        loadLeghe();
    }, []);

    React.useEffect(() => {
        localStorage.setItem('partite-visible-columns', JSON.stringify(visibleColumns));
    }, [visibleColumns]);

    // Statistiche
    const stats = {
        totali: total,
        disputate: partite.filter(p => p.flDisputata).length,
        daGiocare: partite.filter(p => !p.flDisputata && p.flAttivo && !p.flAnnullato).length,
        annullate: partite.filter(p => p.flAnnullato).length,
        leghe: [...new Set(partite.map(p => p.legaId))].length,
        giornate: [...new Set(partite.map(p => p.giornataId))].length
    };

    return (
        <Box sx={{
            p: fullscreen ? 1 : { xs: 2, md: 4 },
            bgcolor: '#f6f7fb',
            minHeight: '100vh',
            position: fullscreen ? 'fixed' : 'relative',
            top: fullscreen ? 0 : 'auto',
            left: fullscreen ? 0 : 'auto',
            right: fullscreen ? 0 : 'auto',
            bottom: fullscreen ? 0 : 'auto',
            zIndex: fullscreen ? 9999 : 'auto'
        }}>
            <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>

                {/* Header */}
                <Box sx={{ mb: 3 }}>
                    <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
                        📅 Gestione Partite
                    </Typography>
                </Box>

                {/* Controlli superiori */}
                <Card sx={{ p: 2, mb: 3, borderRadius: 3, boxShadow: 2 }}>
                    <Grid container spacing={2} alignItems="center">

                        {/* Ricerca */}
                        <Grid item xs={12} md={2}>
                            <TextField
                                fullWidth
                                size="small"
                                placeholder="Cerca squadre, giornata..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                    endAdornment: searchTerm && (
                                        <InputAdornment position="end">
                                            <IconButton size="small" onClick={() => setSearchTerm('')}>
                                                <ClearIcon fontSize="small" />
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                            />
                        </Grid>

                        {/* Filtro Lega */}
                        <Grid item xs={6} md={1.5}>
                            <FormControl fullWidth size="small">
                                <InputLabel>Lega</InputLabel>
                                <Select
                                    value={filterLega}
                                    label="Lega"
                                    onChange={(e) => handleLegaChange(e.target.value)}
                                >
                                    <MenuItem value="all">Tutte</MenuItem>
                                    {leghe.map(lega => (
                                        <MenuItem key={lega.id} value={lega.id}>
                                            {lega.nome || `Lega ${lega.id}`}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* Filtro Stagione */}
                        <Grid item xs={6} md={1.5}>
                            <FormControl fullWidth size="small">
                                <InputLabel>Stagione</InputLabel>
                                <Select
                                    value={filterStagione}
                                    label="Stagione"
                                    onChange={(e) => handleStagioneChange(e.target.value)}
                                    disabled={filterLega === 'all' || loadingStagioni}
                                >
                                    <MenuItem value="all">
                                        {filterLega === 'all' ? 'Seleziona prima una lega' : 'Tutte'}
                                    </MenuItem>
                                    {Array.isArray(stagioni) && stagioni.map(stagione => (
                                        <MenuItem key={stagione.id} value={stagione.id}>
                                            {stagione.nomeComposito || stagione.nome || `Stagione ${stagione.id}`}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {loadingStagioni && (
                                    <Box sx={{ position: 'absolute', right: 32, top: '50%', transform: 'translateY(-50%)' }}>
                                        <CircularProgress size={16} />
                                    </Box>
                                )}
                            </FormControl>
                        </Grid>

                        {/* Filtro Giornata */}
                        <Grid item xs={6} md={1.5}>
                            <FormControl fullWidth size="small">
                                <InputLabel>Giornata</InputLabel>
                                <Select
                                    value={filterGiornata}
                                    label="Giornata"
                                    onChange={(e) => handleGiornataChange(e.target.value)}
                                    disabled={filterLega === 'all' || filterStagione === 'all' || loadingGiornate}
                                >
                                    <MenuItem value="all">
                                        {filterLega === 'all' || filterStagione === 'all' ?
                                            'Seleziona lega e stagione' : 'Tutte'}
                                    </MenuItem>
                                    {Array.isArray(giornate) && giornate.map(giornata => (
                                        <MenuItem key={giornata.id} value={giornata.id}>
                                            {giornata.nomeComposito || giornata.nome || `Giornata ${giornata.numero || giornata.id}`}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {loadingGiornate && (
                                    <Box sx={{ position: 'absolute', right: 32, top: '50%', transform: 'translateY(-50%)' }}>
                                        <CircularProgress size={16} />
                                    </Box>
                                )}
                            </FormControl>
                        </Grid>

                        {/* Filtro Disputata */}
                        <Grid item xs={6} md={1.5}>
                            <FormControl fullWidth size="small">
                                <InputLabel>Disputata</InputLabel>
                                <Select
                                    value={filterDisputata}
                                    label="Disputata"
                                    onChange={(e) => {
                                        setFilterDisputata(e.target.value);
                                        setPage(0);
                                    }}
                                >
                                    <MenuItem value="all">Tutte</MenuItem>
                                    <MenuItem value="disputata">Disputate</MenuItem>
                                    <MenuItem value="da_giocare">Da giocare</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* Filtro Status */}
                        <Grid item xs={6} md={1.5}>
                            <FormControl fullWidth size="small">
                                <InputLabel>Stato</InputLabel>
                                <Select
                                    value={filterStatus}
                                    label="Stato"
                                    onChange={(e) => {
                                        setFilterStatus(e.target.value);
                                        setPage(0);
                                    }}
                                >
                                    <MenuItem value="all">Tutti</MenuItem>
                                    <MenuItem value="active">Attive</MenuItem>
                                    <MenuItem value="inactive">Inattive</MenuItem>
                                    <MenuItem value="hidden">Nascoste</MenuItem>
                                    <MenuItem value="cancelled">Annullate</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* Auto refresh */}
                        <Grid item xs={6} md={1}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={autoRefresh}
                                        onChange={(e) => setAutoRefresh(e.target.checked)}
                                        size="small"
                                    />
                                }
                                label="Auto"
                                sx={{ margin: 0 }}
                            />
                        </Grid>

                        {/* Controlli */}
                        <Grid item xs={12} md={1.5}>
                            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
                                <Tooltip title="Cancella filtri">
                                    <IconButton
                                        size="small"
                                        onClick={resetFilters}
                                        disabled={searchTerm === '' && filterLega === 'all' && filterStagione === 'all' && filterGiornata === 'all' && filterStatus === 'all' && filterDisputata === 'all'}
                                    >
                                        <ClearIcon />
                                    </IconButton>
                                </Tooltip>

                                <Tooltip title="Esporta CSV">
                                    <IconButton
                                        size="small"
                                        onClick={exportToCSV}
                                        disabled={!partite.length}
                                    >
                                        <GetAppIcon />
                                    </IconButton>
                                </Tooltip>

                                <Tooltip title="Configura colonne">
                                    <IconButton
                                        size="small"
                                        onClick={(e) => setAnchorEl(e.currentTarget)}
                                    >
                                        <Badge badgeContent={visibleColumns.length} color="primary">
                                            <SettingsIcon />
                                        </Badge>
                                    </IconButton>
                                </Tooltip>

                                <Tooltip title={fullscreen ? "Esci da schermo intero" : "Schermo intero"}>
                                    <IconButton
                                        size="small"
                                        onClick={toggleFullscreen}
                                    >
                                        {fullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
                                    </IconButton>
                                </Tooltip>

                                <Button
                                    size="small"
                                    variant="outlined"
                                    startIcon={loading ? <CircularProgress size={16} /> : <RefreshIcon />}
                                    onClick={loadPartite}
                                    disabled={loading}
                                    sx={{ textTransform: 'none' }}
                                >
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Card>

                {/* Menu configurazione colonne */}
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={() => setAnchorEl(null)}
                    PaperProps={{
                        sx: { maxHeight: 500, width: 280 }
                    }}
                >
                    <MenuItem onClick={resetToDefault}>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                            Reset a default
                        </Typography>
                    </MenuItem>
                    <Divider />
                    {Object.entries(COLUMN_CONFIG).map(([key, config]) => (
                        <MenuItem key={key} onClick={() => handleColumnToggle(key)}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={visibleColumns.includes(key)}
                                        size="small"
                                    />
                                }
                                label={config.label}
                                sx={{ margin: 0, width: '100%' }}
                            />
                        </MenuItem>
                    ))}
                </Menu>

                {/* Statistiche rapide */}
                <Grid container spacing={2} sx={{ mb: 3 }}>
                    <Grid item xs={6} md={2}>
                        <Card sx={{ p: 2, textAlign: 'center', borderRadius: 2 }}>
                            <Typography variant="h6" sx={{ fontWeight: 700, color: '#4A90E2' }}>
                                {stats.totali}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Partite Totali
                            </Typography>
                        </Card>
                    </Grid>
                    <Grid item xs={6} md={2}>
                        <Card sx={{ p: 2, textAlign: 'center', borderRadius: 2 }}>
                            <Typography variant="h6" sx={{ fontWeight: 700, color: '#4caf50' }}>
                                {stats.disputate}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Disputate (pagina)
                            </Typography>
                        </Card>
                    </Grid>
                    <Grid item xs={6} md={2}>
                        <Card sx={{ p: 2, textAlign: 'center', borderRadius: 2 }}>
                            <Typography variant="h6" sx={{ fontWeight: 700, color: '#1976d2' }}>
                                {stats.daGiocare}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Da giocare (pagina)
                            </Typography>
                        </Card>
                    </Grid>
                    <Grid item xs={6} md={2}>
                        <Card sx={{ p: 2, textAlign: 'center', borderRadius: 2 }}>
                            <Typography variant="h6" sx={{ fontWeight: 700, color: '#f44336' }}>
                                {stats.annullate}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Annullate (pagina)
                            </Typography>
                        </Card>
                    </Grid>
                    <Grid item xs={6} md={2}>
                        <Card sx={{ p: 2, textAlign: 'center', borderRadius: 2 }}>
                            <Typography variant="h6" sx={{ fontWeight: 700, color: '#1565c0' }}>
                                {stats.leghe}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Leghe (pagina)
                            </Typography>
                        </Card>
                    </Grid>
                    <Grid item xs={6} md={2}>
                        <Card sx={{ p: 2, textAlign: 'center', borderRadius: 2 }}>
                            <Typography variant="h6" sx={{ fontWeight: 700, color: '#e65100' }}>
                                {stats.giornate}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Giornate (pagina)
                            </Typography>
                        </Card>
                    </Grid>
                </Grid>

                {/* Tabella principale */}
                <Card sx={{ borderRadius: 3, boxShadow: 2 }}>
                    {error && (
                        <Alert severity="error" sx={{ m: 2 }}>
                            {error}
                        </Alert>
                    )}

                    {loading && !partite.length ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', p: 6 }}>
                            <CircularProgress size={40} />
                        </Box>
                    ) : partite.length > 0 ? (
                        <>
                            <TableContainer sx={{ maxHeight: fullscreen ? 'calc(100vh - 400px)' : 600 }}>
                                <Table stickyHeader size="small">
                                    <TableHead>
                                        <TableRow>
                                            {visibleColumns
                                                .filter(columnKey => COLUMN_CONFIG[columnKey])
                                                .map(columnKey => {
                                                    const config = COLUMN_CONFIG[columnKey];
                                                    return (
                                                        <TableCell
                                                            key={columnKey}
                                                            align={config.align}
                                                            sx={{
                                                                fontWeight: 600,
                                                                width: config.width,
                                                                cursor: config.sortable ? 'pointer' : 'default',
                                                                bgcolor: sortConfig.key === columnKey ? 'rgba(25, 118, 210, 0.08)' : 'inherit',
                                                                '&:hover': config.sortable ? {
                                                                    bgcolor: 'rgba(0, 0, 0, 0.04)'
                                                                } : {},
                                                                borderBottom: '2px solid #e0e0e0'
                                                            }}
                                                            onClick={() => handleSort(columnKey)}
                                                        >
                                                            {config.label}
                                                            {sortConfig.key === columnKey && (
                                                                <span style={{ marginLeft: 4 }}>
                                                                    {sortConfig.direction === 'asc' ? '↑' : '↓'}
                                                                </span>
                                                            )}
                                                        </TableCell>
                                                    );
                                                })}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {partite.map((partita, index) => (
                                            <TableRow
                                                key={partita.partitaId}
                                                sx={{
                                                    '&:hover': {
                                                        bgcolor: 'rgba(0, 0, 0, 0.04)'
                                                    },
                                                    bgcolor: index % 2 === 0 ? 'rgba(0, 0, 0, 0.02)' : 'inherit',
                                                    opacity: partita.flAnnullato ? 0.6 : 1
                                                }}
                                            >
                                                {visibleColumns
                                                    .filter(columnKey => COLUMN_CONFIG[columnKey])
                                                    .map(columnKey => {
                                                        const config = COLUMN_CONFIG[columnKey];
                                                        const value = partita[config.key];

                                                        return (
                                                            <TableCell
                                                                key={columnKey}
                                                                align={config.align}
                                                                sx={{
                                                                    width: config.width,
                                                                    py: 1
                                                                }}
                                                            >
                                                                {config.render ?
                                                                    config.render(value, partita, index) :
                                                                    value || '-'
                                                                }
                                                            </TableCell>
                                                        );
                                                    })}
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            {/* Paginazione */}
                            <TablePagination
                                component="div"
                                count={total}
                                page={page}
                                onPageChange={handlePageChange}
                                rowsPerPage={limit}
                                onRowsPerPageChange={handleLimitChange}
                                rowsPerPageOptions={[10, 25, 50, 100]}
                                labelRowsPerPage="Righe per pagina:"
                                labelDisplayedRows={({ from, to, count }) =>
                                    `${from}-${to} di ${count !== -1 ? count : `più di ${to}`}`
                                }
                                sx={{
                                    borderTop: '1px solid #e0e0e0',
                                    '& .MuiTablePagination-toolbar': {
                                        px: 2
                                    }
                                }}
                            />
                        </>
                    ) : (
                        <Box sx={{ textAlign: 'center', p: 6 }}>
                            <Typography variant="h6" color="text.secondary" gutterBottom>
                                {searchTerm || filterLega !== 'all' || filterStagione !== 'all' || filterGiornata !== 'all' || filterStatus !== 'all' || filterDisputata !== 'all' ?
                                    'Nessuna partita trovata con i filtri applicati' :
                                    'Nessuna partita presente'
                                }
                            </Typography>
                            {(searchTerm || filterLega !== 'all' || filterStagione !== 'all' || filterGiornata !== 'all' || filterStatus !== 'all' || filterDisputata !== 'all') && (
                                <Button
                                    variant="outlined"
                                    onClick={resetFilters}
                                    sx={{ mt: 2 }}
                                >
                                    Cancella filtri
                                </Button>
                            )}
                        </Box>
                    )}
                </Card>

                {/* Dialog dettagli partita */}
                <PartitaDetailDialog
                    open={dialogOpen}
                    onClose={() => setDialogOpen(false)}
                    selectedPartita={selectedPartita}
                    goalPartita={goalPartita}
                    loadingGoal={loadingGoal}
                    cartellinoPartita={cartellinoPartita}
                    loadingCartellini={loadingCartellini}
                    mvpPartita={mvpPartita}
                    loadingMvp={loadingMvp}
                // onEdit={handleEditPartita}
                />

                {/* Dialog Risultato Dettagliato */}
                <Dialog
                    open={resultDialogOpen}
                    onClose={() => setResultDialogOpen(false)}
                    maxWidth="md"
                    fullWidth
                    PaperProps={{
                        sx: {
                            borderRadius: 3,
                            overflow: 'hidden'
                        }
                    }}
                >
                    <DialogTitle sx={{
                        bgcolor: selectedPartitaResult?.flDisputata ? '#e8f5e8' : '#f5f5f5',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                        pb: 2
                    }}>
                        <SoccerIcon sx={{ fontSize: 32, color: '#4caf50' }} />
                        <Box sx={{ flex: 1 }}>
                            <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                Risultati Partita
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {selectedPartitaResult?.giornataNome} • {selectedPartitaResult?.legaNome}
                            </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            {risultatiPartita.filter(r => r.risultatoUfficiale === 1).length > 0 && (
                                <Chip
                                    label="RISULTATO UFFICIALE PRESENTE"
                                    color="success"
                                    size="small"
                                    sx={{ fontWeight: 600 }}
                                />
                            )}
                            <Chip
                                label={`${risultatiPartita.length} risultati`}
                                variant="outlined"
                                size="small"
                            />
                        </Box>
                    </DialogTitle>

                    <DialogContent sx={{ p: 0 }}>
                        {selectedPartitaResult && (
                            <>
                                {loadingRisultati ? (
                                    <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                                        <CircularProgress size={40} />
                                        <Typography variant="body2" sx={{ ml: 2 }}>
                                            Caricamento risultati...
                                        </Typography>
                                    </Box>
                                ) : (
                                    <>
                                        {(() => {
                                            const risultatoUfficiale = risultatiPartita.find(r => r.risultatoUfficiale === 1);
                                            const altriRisultati = risultatiPartita.filter(r => r.risultatoUfficiale === 0);

                                            return (
                                                <>
                                                    {/* RISULTATO UFFICIALE */}
                                                    {risultatoUfficiale ? (
                                                        <Box sx={{ bgcolor: '#e8f5e8', borderBottom: '2px solid #4caf50' }}>
                                                            <Box sx={{ p: 3 }}>
                                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                                                                    <CheckCircleIcon sx={{ color: '#4caf50', fontSize: 20 }} />
                                                                    <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#2e7d32' }}>
                                                                        🏆 RISULTATO UFFICIALE
                                                                    </Typography>
                                                                </Box>

                                                                {/* Header con squadre e risultato ufficiale */}
                                                                <Box sx={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'space-between',
                                                                    bgcolor: 'white',
                                                                    borderRadius: 2,
                                                                    p: 2,
                                                                    boxShadow: 1
                                                                }}>
                                                                    {/* Squadra Casa */}
                                                                    <Box sx={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: 2,
                                                                        flex: 1
                                                                    }}>
                                                                        <Avatar
                                                                            src={selectedPartitaResult.teamCasaFoto}
                                                                            sx={{ width: 40, height: 40 }}
                                                                        >
                                                                            {risultatoUfficiale.teamCasaNome?.charAt(0)}
                                                                        </Avatar>
                                                                        <Box>
                                                                            <Typography variant="body1" sx={{ fontWeight: 600 }}>
                                                                                {risultatoUfficiale.teamCasaNome}
                                                                            </Typography>
                                                                            <Typography variant="caption" color="text.secondary">
                                                                                Casa
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>

                                                                    {/* Risultato Centrale */}
                                                                    <Box sx={{
                                                                        bgcolor: '#4caf50',
                                                                        color: 'white',
                                                                        borderRadius: 2,
                                                                        p: 1.5,
                                                                        minWidth: 100,
                                                                        textAlign: 'center'
                                                                    }}>
                                                                        <Typography variant="h4" sx={{
                                                                            fontWeight: 700,
                                                                            lineHeight: 1
                                                                        }}>
                                                                            {risultatoUfficiale.goalCasa} - {risultatoUfficiale.goalOspite}
                                                                        </Typography>
                                                                        <Typography variant="caption" sx={{ opacity: 0.9 }}>
                                                                            FINALE
                                                                        </Typography>
                                                                    </Box>

                                                                    {/* Squadra Ospite */}
                                                                    <Box sx={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: 2,
                                                                        flex: 1,
                                                                        flexDirection: 'row-reverse'
                                                                    }}>
                                                                        <Avatar
                                                                            src={selectedPartitaResult.teamOspiteFoto}
                                                                            sx={{ width: 40, height: 40 }}
                                                                        >
                                                                            {risultatoUfficiale.teamOspiteNome?.charAt(0)}
                                                                        </Avatar>
                                                                        <Box sx={{ textAlign: 'right' }}>
                                                                            <Typography variant="body1" sx={{ fontWeight: 600 }}>
                                                                                {risultatoUfficiale.teamOspiteNome}
                                                                            </Typography>
                                                                            <Typography variant="caption" color="text.secondary">
                                                                                Ospite
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                </Box>

                                                                {/* Note risultato ufficiale */}
                                                                {risultatoUfficiale.risultatoNote && (
                                                                    <Box sx={{ mt: 2, p: 2, bgcolor: 'rgba(255,255,255,0.7)', borderRadius: 1 }}>
                                                                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                                                                            Note ufficiali:
                                                                        </Typography>
                                                                        <Typography variant="body2">
                                                                            {risultatoUfficiale.risultatoNote}
                                                                        </Typography>
                                                                    </Box>
                                                                )}
                                                            </Box>
                                                        </Box>
                                                    ) : (
                                                        <Alert severity="warning" sx={{ m: 2 }}>
                                                            <Typography variant="body2">
                                                                ⚠️ Nessun risultato ufficiale presente per questa partita
                                                            </Typography>
                                                        </Alert>
                                                    )}

                                                    {/* FORM AGGIUNGI RISULTATO */}
                                                    <Box sx={{ p: 3, bgcolor: '#f5f5f5', borderTop: '1px solid #e0e0e0' }}>
                                                        {!showAddResultForm ? (
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                startIcon={<SportsIcon />}
                                                                onClick={() => setShowAddResultForm(true)}
                                                                fullWidth
                                                                sx={{ py: 1.5 }}
                                                            >
                                                                ➕ Aggiungi Nuovo Risultato
                                                            </Button>
                                                        ) : (
                                                            <Card sx={{ p: 3, bgcolor: 'white', boxShadow: 2 }}>
                                                                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                    <SportsIcon color="primary" />
                                                                    Inserisci Nuovo Risultato
                                                                </Typography>

                                                                <Grid container spacing={2}>
                                                                    {/* Goal Casa */}
                                                                    <Grid item xs={12} md={6}>
                                                                        <TextField
                                                                            fullWidth
                                                                            type="number"
                                                                            label={`⚽ Goal ${selectedPartitaResult?.teamCasaNome || 'Casa'}`}
                                                                            value={newResultForm.goalCasa}
                                                                            onChange={(e) => setNewResultForm({ ...newResultForm, goalCasa: Math.max(0, parseInt(e.target.value) || 0) })}
                                                                            inputProps={{ min: 0, step: 1 }}
                                                                            disabled={creatingResult}
                                                                        />
                                                                    </Grid>

                                                                    {/* Goal Ospite */}
                                                                    <Grid item xs={12} md={6}>
                                                                        <TextField
                                                                            fullWidth
                                                                            type="number"
                                                                            label={`⚽ Goal ${selectedPartitaResult?.teamOspiteNome || 'Ospite'}`}
                                                                            value={newResultForm.goalOspite}
                                                                            onChange={(e) => setNewResultForm({ ...newResultForm, goalOspite: Math.max(0, parseInt(e.target.value) || 0) })}
                                                                            inputProps={{ min: 0, step: 1 }}
                                                                            disabled={creatingResult}
                                                                        />
                                                                    </Grid>

                                                                    {/* Anteprima Risultato */}
                                                                    <Grid item xs={12}>
                                                                        <Box sx={{
                                                                            p: 2,
                                                                            bgcolor: '#e3f2fd',
                                                                            borderRadius: 2,
                                                                            textAlign: 'center',
                                                                            border: '2px solid #1976d2'
                                                                        }}>
                                                                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                                                                                Anteprima Risultato
                                                                            </Typography>
                                                                            <Typography variant="h4" sx={{ fontWeight: 700, color: '#1976d2' }}>
                                                                                {newResultForm.goalCasa} - {newResultForm.goalOspite}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Grid>

                                                                    {/* Note */}
                                                                    <Grid item xs={12}>
                                                                        <TextField
                                                                            fullWidth
                                                                            multiline
                                                                            rows={2}
                                                                            label="📝 Note (opzionale)"
                                                                            value={newResultForm.note}
                                                                            onChange={(e) => setNewResultForm({ ...newResultForm, note: e.target.value })}
                                                                            placeholder="Aggiungi note o commenti sul risultato..."
                                                                            disabled={creatingResult}
                                                                            inputProps={{ maxLength: 1000 }}
                                                                            helperText={`${newResultForm.note.length}/1000 caratteri`}
                                                                        />
                                                                    </Grid>

                                                                    {/* Risultato Ufficiale */}
                                                                    <Grid item xs={12}>
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    checked={newResultForm.flUfficiale === 1}
                                                                                    onChange={(e) => setNewResultForm({ ...newResultForm, flUfficiale: e.target.checked ? 1 : 0 })}
                                                                                    disabled={creatingResult}
                                                                                    color="success"
                                                                                />
                                                                            }
                                                                            label={
                                                                                <Box>
                                                                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                                                                        🏆 Imposta come Risultato Ufficiale
                                                                                    </Typography>
                                                                                    <Typography variant="caption" color="text.secondary">
                                                                                        Se selezionato, questo risultato diventerà immediatamente ufficiale
                                                                                    </Typography>
                                                                                </Box>
                                                                            }
                                                                        />
                                                                    </Grid>

                                                                    {/* Pulsanti Azione */}
                                                                    <Grid item xs={12}>
                                                                        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                                                                            <Button
                                                                                variant="outlined"
                                                                                onClick={() => {
                                                                                    setShowAddResultForm(false);
                                                                                    setNewResultForm({
                                                                                        goalCasa: 0,
                                                                                        goalOspite: 0,
                                                                                        note: '',
                                                                                        flUfficiale: 0
                                                                                    });
                                                                                }}
                                                                                disabled={creatingResult}
                                                                            >
                                                                                Annulla
                                                                            </Button>
                                                                            <Button
                                                                                variant="contained"
                                                                                color="success"
                                                                                startIcon={creatingResult ? <CircularProgress size={16} color="inherit" /> : <CheckCircleIcon />}
                                                                                onClick={handleCreaRisultato}
                                                                                disabled={creatingResult}
                                                                            >
                                                                                {creatingResult ? 'Creazione...' : 'Crea Risultato'}
                                                                            </Button>
                                                                        </Box>
                                                                    </Grid>
                                                                </Grid>
                                                            </Card>
                                                        )}
                                                    </Box>

                                                    {/* ALTRI RISULTATI */}
                                                    {altriRisultati.length > 0 && (
                                                        <Box sx={{ p: 3 }}>
                                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
                                                                <PendingIcon sx={{ color: '#ff9800', fontSize: 20 }} />
                                                                <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#e65100' }}>
                                                                    📋 Altri Risultati Registrati ({altriRisultati.length})
                                                                </Typography>
                                                            </Box>

                                                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                                                {altriRisultati.map((risultato, index) => (
                                                                    <Card
                                                                        key={risultato.Id}
                                                                        sx={{
                                                                            p: 2,
                                                                            bgcolor: '#f8f9fa',
                                                                            border: '1px solid #e0e0e0',
                                                                            position: 'relative',
                                                                            '&:hover': {
                                                                                bgcolor: '#f0f0f0',
                                                                                borderColor: '#1976d2'
                                                                            }
                                                                        }}
                                                                    >
                                                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                                            {/* Risultato */}
                                                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                                                                <Typography variant="h6" sx={{
                                                                                    fontWeight: 700,
                                                                                    color: '#666',
                                                                                    minWidth: 60,
                                                                                    textAlign: 'center',
                                                                                    bgcolor: 'white',
                                                                                    borderRadius: 1,
                                                                                    p: 1
                                                                                }}>
                                                                                    {risultato.goalCasa} - {risultato.goalOspite}
                                                                                </Typography>

                                                                                <Box>
                                                                                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                                                                        Risultato #{risultato.Id}
                                                                                    </Typography>
                                                                                    {risultato.risultatoNote && (
                                                                                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                                                                                            💬 {risultato.risultatoNote}
                                                                                        </Typography>
                                                                                    )}
                                                                                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                                                                                        📅 Creato: {new Date(risultato.createdAt).toLocaleDateString('it-IT')} alle {new Date(risultato.createdAt).toLocaleTimeString('it-IT')}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Box>

                                                                            {/* Azione per rendere ufficiale */}
                                                                            <Box sx={{ textAlign: 'center' }}>
                                                                                <Button
                                                                                    variant="contained"
                                                                                    size="small"
                                                                                    color="success"
                                                                                    onClick={() => handleRendiUfficiale(risultato.Id)}
                                                                                    disabled={loadingRendiUfficiale !== null}
                                                                                    startIcon={
                                                                                        loadingRendiUfficiale === risultato.Id ?
                                                                                            <CircularProgress size={16} color="inherit" /> :
                                                                                            <CheckCircleIcon />
                                                                                    }
                                                                                    sx={{
                                                                                        fontSize: '0.75rem',
                                                                                        minWidth: 140,
                                                                                        '&:hover': {
                                                                                            bgcolor: '#388e3c'
                                                                                        }
                                                                                    }}
                                                                                >
                                                                                    {loadingRendiUfficiale === risultato.Id ?
                                                                                        'Elaborando...' :
                                                                                        'Rendi Ufficiale'
                                                                                    }
                                                                                </Button>

                                                                                {loadingRendiUfficiale !== risultato.Id && (
                                                                                    <Typography variant="caption" color="text.secondary" sx={{
                                                                                        display: 'block',
                                                                                        mt: 0.5,
                                                                                        fontWeight: 500
                                                                                    }}>
                                                                                        🏆 Rendilo ufficiale
                                                                                    </Typography>
                                                                                )}
                                                                            </Box>
                                                                        </Box>

                                                                        {/* Anteprima del cambiamento */}
                                                                        {loadingRendiUfficiale !== risultato.Id && (
                                                                            <Box sx={{
                                                                                mt: 2,
                                                                                p: 1.5,
                                                                                bgcolor: 'rgba(76, 175, 80, 0.1)',
                                                                                borderRadius: 1,
                                                                                border: '1px dashed #4caf50'
                                                                            }}>
                                                                                <Typography variant="caption" color="success.main" sx={{ fontWeight: 600 }}>
                                                                                    ✨ Cosa succederà:
                                                                                </Typography>
                                                                                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                                                                                    • Questo risultato diventerà ufficiale<br />
                                                                                    • Il risultato attualmente ufficiale diventerà non ufficiale<br />
                                                                                    • La partita rimarrà marcata come "disputata"
                                                                                </Typography>
                                                                            </Box>
                                                                        )}
                                                                    </Card>
                                                                ))}
                                                            </Box>

                                                            {/* Messaggio informativo */}
                                                            <Alert severity="success" sx={{ mt: 3 }}>
                                                                <Typography variant="body2">
                                                                    🎯 <strong>Funzionalità attiva:</strong><br />
                                                                    Clicca su "Rendi Ufficiale" per impostare uno di questi risultati come ufficiale.
                                                                    Il sistema disattiverà automaticamente il risultato attualmente ufficiale e aggiornerà lo stato della partita.
                                                                </Typography>
                                                            </Alert>
                                                        </Box>
                                                    )}

                                                    {/* DETTAGLI PARTITA */}
                                                    <Box sx={{ p: 3, bgcolor: '#f5f5f5', borderTop: '1px solid #e0e0e0' }}>
                                                        <Typography variant="subtitle2" gutterBottom sx={{ mb: 2, color: '#1976d2' }}>
                                                            📊 Dettagli Partita
                                                        </Typography>

                                                        <Grid container spacing={2}>
                                                            <Grid item xs={6}>
                                                                <Box sx={{ p: 2, bgcolor: 'white', borderRadius: 1 }}>
                                                                    <Typography variant="caption" color="text.secondary">
                                                                        Data e Ora
                                                                    </Typography>
                                                                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                                                        {selectedPartitaResult.data ?
                                                                            new Date(selectedPartitaResult.data).toLocaleDateString('it-IT') : 'N/A'
                                                                        }
                                                                        {selectedPartitaResult.ore && ` • ${selectedPartitaResult.ore}`}
                                                                    </Typography>
                                                                </Box>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                <Box sx={{ p: 2, bgcolor: 'white', borderRadius: 1 }}>
                                                                    <Typography variant="caption" color="text.secondary">
                                                                        Luogo
                                                                    </Typography>
                                                                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                                                        {selectedPartitaResult.luogo || 'Non specificato'}
                                                                    </Typography>
                                                                </Box>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                <Box sx={{ p: 2, bgcolor: 'white', borderRadius: 1 }}>
                                                                    <Typography variant="caption" color="text.secondary">
                                                                        Giornata
                                                                    </Typography>
                                                                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                                                        {selectedPartitaResult.giornataNome || `G${selectedPartitaResult.giornataNumero || '?'}`}
                                                                    </Typography>
                                                                </Box>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                <Box sx={{ p: 2, bgcolor: 'white', borderRadius: 1 }}>
                                                                    <Typography variant="caption" color="text.secondary">
                                                                        ID Partita
                                                                    </Typography>
                                                                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                                                        #{selectedPartitaResult.partitaId}
                                                                    </Typography>
                                                                </Box>
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </>
                                            );
                                        })()}
                                    </>
                                )}
                            </>
                        )}
                    </DialogContent>

                    <DialogActions sx={{ p: 3, pt: 0, justifyContent: 'space-between' }}>
                        <Box>
                            <Button
                                onClick={() => {
                                    setResultDialogOpen(false);
                                    setShowAddResultForm(false);
                                    setNewResultForm({
                                        goalCasa: 0,
                                        goalOspite: 0,
                                        note: '',
                                        flUfficiale: 0
                                    });
                                }}
                                variant="outlined"
                                disabled={loadingRendiUfficiale !== null || creatingResult}
                            >
                                Chiudi
                            </Button>
                        </Box>

                        <Box sx={{ display: 'flex', gap: 1 }}>
                            <Button
                                variant="contained"
                                onClick={() => {
                                    handleViewPartita(selectedPartitaResult);
                                    setResultDialogOpen(false);
                                    setShowAddResultForm(false);
                                }}
                                startIcon={<InfoIcon />}
                                disabled={loadingRendiUfficiale !== null || creatingResult}
                            >
                                Dettagli Completi
                            </Button>
                        </Box>
                    </DialogActions>
                </Dialog>

                {/* Footer con info */}
                {partite.length > 0 && (
                    <Box sx={{ mt: 2, textAlign: 'center' }}>
                        <Typography variant="body2" color="text.secondary">
                            Ultimo aggiornamento: {new Date().toLocaleString('it-IT')}
                            {autoRefresh && " • Auto refresh attivo"}
                            • Pagina {page + 1} di {Math.ceil(total / limit)}
                            {(searchTerm || filterLega !== 'all' || filterStagione !== 'all' || filterGiornata !== 'all' || filterStatus !== 'all' || filterDisputata !== 'all') &&
                                ` • Filtri applicati`
                            }
                        </Typography>
                    </Box>
                )}

            </motion.div>
        </Box>
    );
}

export default PartitePage;